import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";
import type { inlineWidgetContent$key } from "~/queries/__generated__/inlineWidgetContent.graphql";

import { Container, StyledContentNewsletterWidget } from "./styles";

type Props = {
  reference: inlineWidgetContent$key;
} & ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const content = useFragment(
    graphql`
      fragment inlineWidgetContent on Content {
        ...contentNewsletterWidgetContent
      }
    `,
    reference_,
  );
  return (
    <Container>
      <StyledContentNewsletterWidget reference={content} />
    </Container>
  );
};

Component.displayName = "InlineWidget";
export const InlineWidget = styled(Component)``;
